import { useEffect } from 'react'

import { INTEGRATION_KEY } from '~/@common/integration/constants'
import { INTEGRATION_IFRAME_MESSAGE } from '~/@common/integration/messageProtocol'
import { envUtils } from '~/@common/utils/envUtils'

// dev panel 이 원격으로 청소 가능한 키 화이트리스트 — 임의 key 침투 차단.
const ALLOWED_KEYS: ReadonlyArray<string> = [
  INTEGRATION_KEY.MIGRATION_DONE,
  INTEGRATION_KEY.TRANSFERRED,
  INTEGRATION_KEY.DEV_FORCE_ROLE,
]

const parseOrigin = (value: string | null): string | null => {
  if (!value) return null
  try {
    return new URL(value).origin
  } catch {
    return null
  }
}

// ★ 통합 마이그레이션 dev panel 원격 reset 라우트 (/integration/dev-reset).
//   receiver dev panel 이 sender 의 marker 를 원격 청소할 때 띄우는 iframe.
//
//   흐름:
//     ① 부모 (dev panel) 가 iframe src 에 ?from=<자기 origin>&keys=<csv> 를 박아 띄움
//     ② iframe 안에서 본 컴포넌트 마운트 → useEffect 가 ALLOWED_KEYS 와 교집합만 제거
//     ③ DEV_RESET_DONE postMessage 로 ACK
//
//   라이브에선 즉시 return — dev panel 자체가 라이브에 mount 안 되지만 fail-safe.
//   인라인이 아닌 React 마운트 후 동작 — dev panel 측 3s timeout 안에 충분.
const IntegrationDevResetPage = () => {
  useEffect(() => {
    if (envUtils.isLive) return
    if (window.self === window.top) return // top-level 직접 진입 무시 — iframe 전용

    const params = new URLSearchParams(window.location.search)
    const fromOrigin = parseOrigin(params.get('from'))
    if (!fromOrigin) return

    const requested = (params.get('keys') ?? '').split(',').filter(Boolean)
    const cleared = requested.filter((key) => ALLOWED_KEYS.includes(key))
    cleared.forEach((key) => localStorage.removeItem(key))

    window.parent.postMessage(INTEGRATION_IFRAME_MESSAGE.DEV_RESET_DONE(cleared), fromOrigin)
  }, [])

  return null
}

export default IntegrationDevResetPage
